/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DecodeReinitTokenResponse } from '../../models/decode-reinit-token-response';

export interface DecodeReinitToken$Params {

/**
 * The reinit token
 */
  token: string;
}

export function decodeReinitToken(http: HttpClient, rootUrl: string, params: DecodeReinitToken$Params, context?: HttpContext): Observable<StrictHttpResponse<DecodeReinitTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, decodeReinitToken.PATH, 'post');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DecodeReinitTokenResponse>;
    })
  );
}

decodeReinitToken.PATH = '/personalspace/decode-reinit-token';
